export default __webpack_public_path__ + "static/media/brandImage.eeca585c.png";